import * as React from 'react';
import { Box, Text, Collapse, Flex, Button } from '@chakra-ui/react';
import queryString from 'query-string';
import { IoIosArrowDown } from 'react-icons/io';
import { MdLocationOn, MdTune, MdCheck } from 'react-icons/md'
import { motion } from 'framer-motion'

import filterTypes from '../../utitlities/filterTypes';

import AllEffects from '../../components/AllEffects';
import AllProductCategories from '../../components/AllProductCategories';
import AllLineages from '../../components/AllLineages';
import AllProductSubcategories from '../../components/AllProductSubcategories';
import AllStoreTypes from '../../components/AllStoreTypes';
import LinkWrapper from '../../components/LinkWrapper';

/* IMPORT APP CONTEXT */
import { AppContext } from '../../context';

const isBrowser = typeof window !== "undefined";

function FiltersBar(props) {
  const { 
    filterItems, 
    objFilters, 
    onCheckedStateChanged,
    slashQuery, 
    statesAvailable, 
    productsToFilter,
    showFilterResults, 
    clearFilters,
    isMobile,
    topBarFilter,
    pathname,
    location,
  } = props;
  
  const appContext = React.useContext(AppContext);

  React.useEffect(() => {
    // console.log('filters bar loaded');
    // isBrowser
    if (false) {
      const filterOptionsElems = document.querySelectorAll('.filter-option-title');

      if (filterOptionsElems) {
        let observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            entry.target.classList.toggle('passed-scroll-opacity', !entry.isIntersecting);
          });
        }, {threshold: 0.99});

        filterOptionsElems.forEach(item => {
          observer.observe(item);
        });
      }

    }
  }, []);

  /********************************
   * COLLAPSE FILTER BAR
  ********************************/
  const [showFilterBar, setShowFilterBar] = React.useState(isMobile ? false : true);

  /* CONTROL WHEN CLEAR BUTTON SHOWS UP */
  const [showClearButton, setShowClearButton] = React.useState(false);

  React.useEffect(() => {
    const includesFilters = location?.href?.includes('state') || location?.href?.includes('classAndRatios') || location?.href?.includes('effect') || location?.href?.includes('storeType');

    includesFilters ? setShowClearButton(true) : setShowClearButton(false);

  }, [location]);

  React.useEffect(() => {
    if (isMobile) {
      const queryStr = queryString.stringify(objFilters, { arrayFormat: 'comma' });

      if (queryStr.includes('state') || queryStr.includes('classAndRatios') || queryStr.includes('effect') || queryStr.includes('storeType')) {
        setShowClearButton(true);
      }
    }

  }, [objFilters]);

  /* FILTER OPTION OPEN-CLOSE STATE */
  const [filterOptionOpen, setFilterOptionOpen] = React.useState(0);

  return (
    <Box
      w="100%"
      position="relative"
    >
      {/* MOBILE FILTERS HEADER */}
      <Box
        w="100%"
        role="button"
        display={{base:'flex', md:'none'}}
        mt={{base:'15px'}}
        justifyContent="space-between"
        alignItems="center"
        position="relative"
        borderBottom="1px"
        borderColor="primary"
        onClick={() => {
          setShowFilterBar(!showFilterBar);
          // appContext.actions.checkIfFiltersBarOpen(!showFilterBar);
        }}
      >
        <Text
          fontSize={{base:'16px'}}
          fontWeight={{base:'900'}}
          lineHeight={{base:'36px'}}
          letterSpacing="1.7px"
          color="primary"
          textTransform="uppercase"
        >
          {'filter options'}
        </Text>

        <motion.div 
          animate={{
            rotate: showFilterBar ? 180 : 0,
            transition: { duration: 0.65 },
          }}
        >
          <IoIosArrowDown style={{color:'#272158', width:'20px', height:'20px'}}/>
        </motion.div>
      </Box>

      {/* BUTTONS */}
      <Box 
        display={{
          base:showFilterBar ? 'block' : 'none', 
          md:'block',
        }}
        w="100%"
        h="auto"
        position={{base:'static', md:'absolute'}}
        top="-70px"
      >
        <Flex
          w="100%"
          justifyContent={{base:'center', md:'flex-start'}}
          alignItems="center"
          borderBottom={{
            base: showClearButton ? '1px' : '0px', 
            md:'0',
          }}
          borderColor="primary"
          pb={{
            base: showClearButton ? '15px' : '0', 
            md:'0',
          }}
        >
          {/* SHOW RESULTS BUTTON - JUST FOR MOBILE */}
          {showClearButton && (
            <FilterButton 
              bgColor={"primary"}
              text={"show results"}
              onClick={() => {
                showFilterResults();
                setShowFilterBar(!showFilterBar);
              }}
              display={{base:'flex', md:'none'}}
              mr={{base:showClearButton ? '10px' : '0', md:'0'}}
            />
          )}

          {/* CLEAR FILTERS BUTTON */}
          {showClearButton && (
            <FilterButton 
              bgColor={"blue"}
              text={"clear filters"}
              onClick={() => {
                clearFilters();
              }}
              display={{base:'flex'}}
              _hover={{bg:isMobile ? 'blue' : 'primary'}}
            />
          )}

        </Flex>
      </Box>

      {/* FILTER OPTIONS */}
      <Collapse startingHeight={0} in={showFilterBar}>
        <Flex
          w="100%"
          h="auto" //{{base:'auto', md:'858px'}}
          direction="column"
          mt={{base:'0px', md:'0px'}}
          maxH={{
            base: showClearButton ? 'auto' : 'auto', //base: showClearButton ? '53vh' : '66vh', 
            md:'85vh',
          }}
          overflowY="scroll"
          className="hide-scrollbar hide-scrollbar-firefox"
          borderTop={{base:'0', md:'1px'}}
          borderColor="primary"
        >
          {/* FILTER OPTIONS */}
          <Box
            w="100%"
          >
            {filterItems.map((filter, indx) => {
              
              return (
                <FilterOption 
                  key={indx} 
                  index={indx} 
                  title={filter.title} 
                  objFilters={objFilters}
                  slashQuery={slashQuery}
                  onCheckedStateChanged={onCheckedStateChanged} 
                  statesAvailable={statesAvailable}
                  productsToFilter={productsToFilter}
                  isOpen={objFilters[filter.name]?.length > 0}
                  filterOptionOpen={filterOptionOpen}
                  setFilterOptionOpen={(indx) => setFilterOptionOpen(indx)}
                  topBarFilter={topBarFilter}
                  pathname={pathname}
                />
              );
            })}
          </Box>
        </Flex>
      </Collapse>
    </Box>
  );
}

/* BUTTON */
const FilterButton = (props) => {
  const { color, bgColor, text, onClick, display, _hover, mr } = props;

  return (
    <Button
      w={{base:'120px', md:'105px'}}
      display={display}
      justifyContent="center"
      alignItems="center"
      bgColor={bgColor}
      borderRadius="0px"
      mt="15px"
      mr={mr}
      p="10px"
      color={color || 'white'}
      fontSize={{base:'15px'}}
      fontWeight="bold"
      letterSpacing={{base:'0'}}
      lineHeight="1"
      textTransform="capitalize"
      _hover={_hover}
      onClick={onClick}
      className="fadeIn"
    >
      {text}
    </Button>
  );
};

/* FILTER BAR OPTION */
const FilterOption = (props) => {
  const { index, title, objFilters, slashQuery, onCheckedStateChanged, statesAvailable, isOpen, filterOptionOpen, setFilterOptionOpen, topBarFilter, pathname } = props;

  React.useEffect(() => {
    isOpen ? setFilterOptionOpen(index) : null;
  }, [isOpen]);
  
  const getFilterList = () => {
    switch (title) {
      case 'product':
        return (
          <AllProductCategories 
            Item={(data) => <FilterItemWithSubCategories filterType={data.filterType} item={data.item} objFilters={objFilters} onCheckedStateChanged={onCheckedStateChanged} />} 
          />
        );
      case 'class and ratios':
        return (
          <AllLineages 
            Item={(data) => <FilterItem filterType={data.filterType} item={data.item} checked={objFilters[data.filterType].includes(data.item.slug.current)} onCheckedStateChanged={onCheckedStateChanged} />} 
          />
        );
      case 'effect':
        return (
          <AllEffects 
            Item={(data) => <FilterItem filterType={data.filterType} item={data.item} checked={objFilters[data.filterType].includes(data.item.slug.current)} onCheckedStateChanged={onCheckedStateChanged} />} 
          />
        );
      case 'store':
        return (
          <AllStoreTypes 
            Item={(data) => <FilterItem filterType={data.filterType} item={data.item} checked={objFilters[data.filterType].includes(data.item.slug.current)} onCheckedStateChanged={onCheckedStateChanged} />} 
          />
        );
      case 'subcategory':
        return (
          <AllProductSubcategories 
            category={slashQuery}
            Item={(data) => <FilterItem filterType={data.filterType} item={data.item} checked={objFilters[data.filterType].includes(data.item.slug.current)} onCheckedStateChanged={onCheckedStateChanged} />} 
          />
        );
      case 'state availability':
        const states = statesAvailable.map((item, indx) => <FilterItem key={indx} filterType={filterTypes.STATE} item={item} checked={objFilters[filterTypes.STATE].includes(item.slug.current)} onCheckedStateChanged={onCheckedStateChanged} />);
        return states;
      case 'product type':
        const productTypes = topBarFilter.map((productType, indx) => {
          return (
            <LinkWrapper key={indx} href={productType.link}>
              <Text
                w="max-content"
                color={productType.link === pathname ? 'blue' : 'primary'}
                fontFamily="Outfit"
                fontSize="18px"
                lineHeight="1"
                letterSpacing="0"
                borderBottom="1px"
                borderColor="transparent"
                _hover={{color: '#01A7CF', borderColor: '#01A7CF'}}
                textTransform="capitalize"
                mb={indx === (topBarFilter.length - 1) ? '0' : '22px'}
              >
                {productType.text === 'all' ? 'all products' : productType.text}
              </Text>
            </LinkWrapper>
          );
        });
        return productTypes;
    }
  }

  return (
    <Box
      borderBottom="1px"
      borderColor="primary"
      position="relative"
      role="button"
    >
      <Box
        pt={{base:'15px'}}
        pb={{base:'15px'}}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        position="relative"
        onClick={() => {
          index !== filterOptionOpen ? setFilterOptionOpen(index) : setFilterOptionOpen(-1);
        }}
        className="filter-option-title"
      >
        <Text
          fontSize={{base:'15px', md:'18px'}}
          fontWeight={{base:'900'}}
          color="primary"
          textTransform="uppercase"
        >
          {title}
        </Text>

        <motion.div 
          animate={{
            rotate: index === filterOptionOpen ? 180 : 0,
            transition: { duration: 0.65 },
          }}
        >
          <IoIosArrowDown style={{color:'#272158', width:'20px', height:'20px'}}/>
        </motion.div>
      </Box>

      <Collapse startingHeight={0} in={index === filterOptionOpen}>
        <Box pb={{base:'15px'}} pt={{base:'-10px'}}>
          {getFilterList()}
        </Box>
      </Collapse>
    </Box>
  );
};

/* FILTER BAR OPTION ITEM */
const FilterItem = (props) => {
  const { filterType, item, onCheckedStateChanged, checked } = props;

  // filterType === 'state' ? console.log('ITEM: ', filterType, item, checked) : null;

  return (
    <Box
      display="flex"
      justifyContent="flex-start"
      alignItems="center"
      mt={{base:'5px'}}
      onClick={() => {
        onCheckedStateChanged({filterType: filterType, value: item.slug.current });
      }}
      role="button"
      pl={{base:'10px', md:'20px'}}
      className="filter-option-title"
    >
      <Box 
        w={{base:'13.53px'}}
        h={{base:'13.53px'}}
        bgColor={checked ? 'primary' : 'white'}
        borderRadius={{base:'2px'}}
        border="1px"
        borderColor="primary"
      >
        <MdCheck style={{width:'100%', height:'100%', color:'white'}} />
      </Box>

      <motion.div whileHover={{ marginLeft: '10px' }}>
        <Text
          fontSize={{base:'18px'}}
          color="primary"
          ml={{base:'5px'}}
          textTransform="capitalize"
        >
          {item.name}
        </Text>
      </motion.div>
    </Box>
  );
};

/* FILTER BAR OPTION ITEM WITH SUBCATEGORIES */
const FilterItemWithSubCategories = (props) => {
  const { filterType, item, objFilters, onCheckedStateChanged } = props;
  
  return (
    <Box>
      <FilterItem filterType={filterType} item={item} checked={objFilters[filterType].includes(item.slug.current)} onCheckedStateChanged={onCheckedStateChanged} />
      <Box 
        ml={{base:'30px'}}
      >
        {item.subcategories.length > 0 && (
          <AllProductSubcategories
            category={item.slug.current} 
            Item={(data) => <FilterItem filterType={data.filterType} item={data.item} checked={objFilters[data.filterType].includes(data.item.slug.current)} onCheckedStateChanged={onCheckedStateChanged} />} 
          />
        )}
      </Box>
    </Box>
  );
};

/* REMOVED ZIP CODE OPTION */
const zipCodeOption = () => {
  /********************************
   * ZIP CODE CONTROL
  ********************************/

  /* ZIP CODE STATE */
  const [zipCode, setZipCode] = React.useState('');

  /* ON SUBMIT ZIP CODE */
  const onSubmitZipCode = (event) => {
    event.preventDefault();
    // console.log('zipCode is: ', zipCode);
  }

  return (
    <Box
      w="100%"
      h={{base:'170px', md:'100%'}}
      bgColor="primaryDarker"
      display="grid"
      gridTemplateRows={{base:'29.5% 70.5%'}}
    >
      {/* TOP */}
      <Box
        w="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        borderBottom="1px"
        borderColor="white"
      >
        <Text
          color="white"
          fontSize={{base:'14px', md:'12px', lg:'12px', xl:'14px'}}
          fontWeight="900"
          lineHeight={{base:'18px'}}
          letterSpacing={{base:'1px'}}
        >
          FILTER BY LOCATION
        </Text>
      </Box>

      {/* BOTTOM */}
      <Box
        w="100%"
        h="100%"
        display="grid"
        gridTemplateRows={{base:'22% 33.5% 44.5%'}}
      >
        {/* SPACE */}
        <Box></Box>

        {/* ZIP CODE */}
        <Box
          w="100%" 
          h="100%"
        >
          <Box
            w={{base:'70%', ms:'60%', md:'80%', lg:'80%', xl:'75%'}}
            h="100%"
            bgColor="white"
            m="auto"
          >
            <form 
              onSubmit={(event) => onSubmitZipCode(event)}
              style={{
                maxWidth:'100%',
                height:'100%',
              }}
            >
              <input
                value={zipCode}
                onChange={(event) => setZipCode(event.target.value)}
                placeholder="ZIP CODE"
                style={{
                  width:'100%',
                  height:'100%',
                  outlineStyle:'none',
                  fontWeight:'800',
                  paddingLeft:'10px',
                }}
              />
            </form>
          </Box>
        </Box>

        {/* USE CURRENT LOCATION */}
        <Box
          w="100%"
          h="100%"
        >
          <Box
            w={{base:'70%', ms:'60%', md:'80%', lg:'80%', xl:'75%'}}
            h="100%"
            m="auto"
            display="flex"
            justifyContent="center"
            alignItems="center"
            role="button"
            onClick={() => setZipCode('12345')}
          >
            <MdLocationOn style={{color:'white', width:'24px', height:'24px'}} />

            <Box
              borderBottom="1px"
              borderColor="white"
            >
              <Text
                color="white"
                fontSize={{base:'14px', md:'10px', lg:'10px', xl:'14px'}}
                fontWeight="bold"
                letterSpacing={{base:'0'}}
                lineHeight={{base:'18px'}}
              >
                Use Current Location
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

/* FILTER BUTTON REMOVED */
const FilterButtonRemoved = () => {
  return (
    <Box 
      maxW="max-content"
      h="auto"
      display={{base:'flex', md:'none'}}
      justifyContent="flex-start"
      alignItems="center"
      role="button"
      border="1px"
      borderColor="primary"
      borderRadius="5px"
      p="4px"
      onClick={() => setShowFilterBar(!showFilterBar)}
    >
      <MdTune style={{color:'#272158', width:'24px', height:'24px'}} />

      <Box>
        <Text
          color="primary"
          fontSize={{base:'18px'}}
          fontWeight="bold"
          letterSpacing={{base:'0'}}
          lineHeight={{base:'18px'}}
          px="5px"
        >
          Filters
        </Text>
      </Box>

    </Box>
  );
};

export default FiltersBar;
